import { useEffect, useState } from "react";
import { apiClient } from "../../services/api/apiClient";
import EditIcon from "../../assets/Edit.svg";
import DuctStepModal from "./DuctStepModal";
import { ductSystemSteps } from "./stepConfigurations";

export default function DuctSpecification({ ductSubmittal }) {
  const [specifications, setSpecifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initialStep, setInitialStep] = useState(0);

  useEffect(() => {
    const fetchSpecification = async () => {
      try {
        const response = await apiClient.get(
          `/duct-schedule/specification/${ductSubmittal.id}`
        );
        console.log(response);
        // Convert object with numeric keys to array, preserving step numbers
        const specsArray = response.data
          ? Object.entries(response.data).map(([stepNumber, specData]) => ({
              stepNumber: parseInt(stepNumber),
              ...specData,
            }))
          : [];
        setSpecifications(specsArray);
      } catch (error) {
        console.error("Error fetching specifications:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSpecification();
  }, [ductSubmittal]);

  const handleEdit = (stepNumber) => {
    // stepNumber is 1-based, but DuctStepModal expects 0-based index
    setInitialStep(stepNumber - 1);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    // Refetch specifications after modal closes to get updated data
    fetchSpecifications();
  };

  const fetchSpecifications = async () => {
    try {
      const response = await apiClient.get(
        `/duct-schedule/specification/${ductSubmittal.id}`
      );
      // Convert object with numeric keys to array, preserving step numbers
      const specsArray = response.data
        ? Object.entries(response.data).map(([stepNumber, specData]) => ({
            stepNumber: parseInt(stepNumber),
            ...specData,
          }))
        : [];
      setSpecifications(specsArray);
    } catch (error) {
      console.error("Error fetching specifications:", error);
    }
  };

  const renderFieldData = (fieldData) => {
    if (!fieldData || Object.keys(fieldData).length === 0) {
      return (
        <p className="text-sm text-gray-500 italic">No field data available</p>
      );
    }

    return (
      <div className="space-y-2">
        {Object.entries(fieldData).map(([key, value]) => (
          <div key={key} className="flex">
            <span className="text-sm font-medium text-gray-600 min-w-[200px]">
              {key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}:
            </span>
            <span className="text-sm text-gray-900 flex-1">
              {Array.isArray(value) ? (
                <div className="space-y-1">
                  {value.map((item, index) => (
                    <div key={index} className="flex items-center">
                      <span className="w-2 h-2 bg-gray-400 rounded-full mr-2"></span>
                      {item}
                    </div>
                  ))}
                </div>
              ) : (
                value
              )}
            </span>
          </div>
        ))}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold mb-4">Specification</h3>
        <div className="flex items-center justify-center py-8">
          <div className="text-gray-500">Loading specifications...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      {specifications.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          No specifications found for this submittal
        </div>
      ) : (
        <div className="space-y-4">
          {specifications.map((spec) => (
            <div
              key={spec.stepNumber}
              className="border border-gray-200 rounded-lg p-5 hover:shadow-md transition-shadow"
            >
              <div className="flex justify-between items-start mb-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      {spec.specSection}
                    </span>
                    <h4 className="text-base font-semibold text-gray-900">
                      {spec.sectionTitle}
                    </h4>
                    {spec.inc && (
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                        Included
                      </span>
                    )}
                    {!spec.inc && (
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
                        Not Included
                      </span>
                    )}
                  </div>
                </div>
                <button
                  onClick={() => handleEdit(spec.stepNumber)}
                  className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
                >
                  <img src={EditIcon} alt="Edit" className="w-4 h-4" />
                  Edit
                </button>
              </div>

              {spec.inc && ![2, 3, 5, 6].includes(spec.stepNumber) && (
                <div className="bg-gray-50 rounded-md p-4">
                  {renderFieldData(spec.fieldData)}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Duct Step Modal */}
      <DuctStepModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        steps={ductSystemSteps}
        initialStep={initialStep}
        editMode={true}
      />
    </div>
  );
}

/*
Duct Liner
Sealants
Turning Vanes
Access Doors
*/
